import { lazy } from "react";
import { officeBuildingSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "companies" */ './components/EntryPoint'));
const CompaniesLoader = lazy(() => import(/* webpackChunkName: "companiesLoader" */ './components/CompaniesLoader'));
const FormCompany = lazy(() => import(/* webpackChunkName: "formCompany" */ './components/FormCompany'));

export const defaultPath = '/companies';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: CompaniesLoader,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'companies_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: FormCompany,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'create_company',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: FormCompany,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'modify_company',
            plural: false
        }
    }
];

const Companies = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: officeBuildingSVG,
    title: {
        key: 'companies',
        plural: false
    },
    subTitle: {
        key: 'companies_list',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Companies;
